const toDecimal = (num, precision = 2) => {
    precision = Math.pow(10, precision);
    return Math.round(num * precision) / precision;
};

export { toDecimal };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/to-decimal.mjs
// module id = OoOU
// module chunks = 0